import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sidebar } from "./Sidebar";
import { SidebarProvider, useSidebar } from "./SidebarContext";

function DashboardLayoutInner({ children }: { children: React.ReactNode }) {
  const { isMobile, setMobileOpen } = useSidebar();

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "232px 1fr",
        minHeight: "100vh",
        background: "#FAFBFD",
      }}
    >
      {!isMobile && <Sidebar />}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          overflow: "hidden",
        }}
      >
        {/* Mobile-only top bar */}
        {isMobile && (
          <header
            style={{
              height: 56,
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "0 16px",
              background: "#001847",
              color: "#FAFBFD",
            }}
          >
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMobileOpen(true)}
              style={{ color: "#FAFBFD" }}
            >
              <Menu className="h-5 w-5" />
            </Button>
            <span
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 800,
                fontSize: 18,
                color: "#FAFBFD",
              }}
            >
              Waypoint
            </span>
          </header>
        )}

        {/* Scrollable content */}
        <main
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "32px 40px",
            background: "#FAFBFD",
          }}
        >
          <div style={{ maxWidth: 1100, margin: "0 auto" }}>{children}</div>
        </main>
      </div>

      {/* Mobile sidebar overlay */}
      {isMobile && <Sidebar />}
    </div>
  );
}

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <DashboardLayoutInner>{children}</DashboardLayoutInner>
    </SidebarProvider>
  );
}
